import * as Types from 'src/actions/modal/close/Types';
import { Action } from 'redux';
import { ActionCreator } from 'react-redux';

export interface CloseModal extends Action {
  type: Types.CLOSE_MODAL;
}

export const closeModal: ActionCreator<CloseModal> = () => {
  return (
    {
      type: Types.CLOSE_MODAL
    }
  );
};



// WEBPACK FOOTER //
// ./src/actions/modal/close/Close.actions.tsx